import * as React from 'react';
import { Resolution } from '../data/Resolution';
import { getCanvasScale } from '../state/Store';
import { generateClassName } from '../utils';

interface Props {
  reactangle: PIXI.Rectangle;
  rotation: number;
  stageResolution: Resolution;
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export class HoverBox extends React.Component<Props> {
  render() {
    const r = this.props.reactangle;
    const scale = getCanvasScale();
    const width = r.width * scale;
    const height = r.height * scale;

    const cx = (r.left + r.width / 2) * scale;
    const cy = (r.top + r.height / 2) * scale;
    const wh = width / 2;
    const hh = height / 2;
    return (
      <div
        className={generateClassName('bounding-box', {
          hover: true
        })}
      >
        <div
          className="sprite"
          style={{
            position: 'absolute',
            left: cx,
            top: cy,
            transform: `rotate(${this.props.rotation}deg)`
          }}
        >
          <div
            className="line"
            style={{
              top: -hh,
              left: -wh,
              width: width,
              height: 0
            }}
          />
          <div
            className="line"
            style={{
              top: -hh,
              left: wh,
              width: 0,
              height: height
            }}
          />
          <div
            className="line"
            style={{
              top: hh,
              left: -wh,
              width: width,
              height: 0
            }}
          />
          <div
            className="line"
            style={{
              top: -hh,
              left: -wh,
              width: 0,
              height: height
            }}
          />
          <div
            className="box"
            style={{
              left: -wh,
              top: -hh,
              width,
              height
              // cursor: /*this.props.isEditingContent ? 'text' :*/ 'grab'
            }}
            onMouseDown={this.props.onClick}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/showcase/HoverBox.tsx